import { useCallback, useMemo } from 'react';
import uuid from 'uuid/v1';
import { CHAT_AGENT_ACTION_TYPE } from '../config/chatAgentActionType';
import { CHAT_AGENT_COMPONENT_TYPE } from '../config/chatAgentComponentType';
import { CHAT_DIALOG_MESSAGE_PROP_PATH } from '../config/chatDialogMessagePropPath';

export const useChatTools = ({ openChat, closeChat, forwardResponseToChatAgent }) => {
    const sendMessage = useCallback(
        ({ message }) => {
            const messageObject = {
                id: uuid(),
                componentData: {
                    value: message,
                    isUserMessage: true,
                    componentName: CHAT_AGENT_COMPONENT_TYPE.TEXT,
                },
                flows: [{ id: uuid(), actions: [{ id: uuid(), type: CHAT_AGENT_ACTION_TYPE.MESSAGE }] }],
            };

            forwardResponseToChatAgent({ [CHAT_DIALOG_MESSAGE_PROP_PATH]: messageObject, actions: [] });
        },
        [forwardResponseToChatAgent]
    );

    const open = useCallback(() => {
        openChat();
        return true;
    }, [openChat]);
    const close = useCallback(() => {
        closeChat();
        return true;
    }, [closeChat]);

    const quickAnswersComponent = useCallback(
        ({ quickAnswers }) => {
            const message = {
                id: uuid(),
                componentData: {
                    value: quickAnswers.map(({ label }) => label),
                    componentName: CHAT_AGENT_COMPONENT_TYPE.QUICK_ANSWERS,
                },
                flows: quickAnswers.map(({ methodName, args }, index) => ({
                    id: index,
                    actions: [{ data: { methodName, args }, type: CHAT_AGENT_ACTION_TYPE.METHOD }],
                })),
            };
            forwardResponseToChatAgent({ [CHAT_DIALOG_MESSAGE_PROP_PATH]: message, actions: [] });
        },
        [forwardResponseToChatAgent]
    );

    return useMemo(
        () => ({
            sendMessage,
            quickAnswers: quickAnswersComponent,
            open,
            close,
        }),
        [close, open, sendMessage, quickAnswersComponent]
    );
};
